/** @jsxImportSource @emotion/react */
import { Field } from 'formik'

import { data, notification, notificationTypes } from './notificationsData'
import { CheckboxInput } from 'components/atoms/Checkbox'

type NotificationView = 'default' | 'physicianGroup'

const physicianGroupFlags = new Set<notificationTypes>([
  notificationTypes.HST_ORDER_CREATED,
  notificationTypes.ORDER_CANCELLED,
  notificationTypes.NEW_REPORT_READY_COX,
  notificationTypes.NEW_REPORT_READY_HST,
  notificationTypes.NEW_REPORT_READY_POX,
])

type Props = {
  view?: NotificationView
}

export const NotificationPreferences = ({
  view,
}: Props) => {
  const rows: JSX.Element[] = []
  const isPhysicianGroupView = view === 'physicianGroup'

  Object.keys(data).forEach((key: string): void => {
    const filteredNotifications = data[key].filter((n: notification) =>
      !isPhysicianGroupView || physicianGroupFlags.has(n.flag),
    )

    if (!filteredNotifications.length) {
      return
    }

    if (!isPhysicianGroupView) {
      rows.push(
        <tr>
          <td colSpan={4} css={{ fontWeight: 'bold' }} className="text-gray py-2">
            {key.slice(0, 1).toUpperCase() + key.slice(1)}
          </td>
        </tr>,
      )
    }

    filteredNotifications.forEach((n: notification) => {
      const name = isPhysicianGroupView ? n.flag : `EMAIL_${n.flag}`

      rows.push(
        <tr key={n.flag}>
          <td css={{ textAlign: 'center', paddingTop: '5px' }}>
            <Field
              id={name}
              name={name}
              component={CheckboxInput}
              label=""
            />
          </td>
          <td>{n.label}</td>
          <td>{n.description}</td>
        </tr>,
      )
    })
  })

  const table = (
    <div
      css={isPhysicianGroupView ? {
        '& .custom-control': {
          paddingLeft: 0,
        },
        '& .custom-control .form-check-input': {
          marginLeft: '0 !important',
        },
      } : undefined}>
      <table css={{ borderCollapse: 'collapse', width: '100%' }}>
        <thead css={{ borderBottom: '1px solid rgb(206, 212, 218)' }}>
          <tr>
            {!isPhysicianGroupView ? (
              <th css={{ width: '80px' }} className="text-gray">
                Email
              </th>
            ) : (
              <th css={{ width: '44px' }} />
            )}
            <th
              css={{
                width: isPhysicianGroupView ? '260px' : '200px',
                paddingBottom: isPhysicianGroupView ? '0.75rem' : undefined,
              }}
              className="text-gray">
              Notification
            </th>
            <th
              css={{
                width: 'auto',
                paddingBottom: isPhysicianGroupView ? '0.75rem' : undefined,
              }}
              className="text-gray">
              Description
            </th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  )

  if (isPhysicianGroupView) {
    return table
  }

  return (
    <div className="card-body row" css={{ paddingTop: 0 }}>
      <div className="col-md-12 mb-3">
        <div className="card card-primary p-2">
          <div
            className="card-header"
            css={{
              color: 'black !important',
              backgroundColor: 'transparent !important',
            }}>
            <h3 className="card-title">NOTIFICATION PREFERENCES</h3>
          </div>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col">
                {table}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
